'use strict';

import { Dropdown } from './dropdown.js';

export class DropdownMenublogcategories extends Dropdown {
	constructor(component_key) {
		super(component_key);
	}
	add_events() {
		const option_selector = `.js-${this.id}_option`;
		this.$selected.on('click', option_selector, (event) => {
			const handler = this.selected_click_handler;
			handler.call(this, event);
		});
		this.$list.on('click', option_selector,
			this.option_click_handler.bind(this)
		);
		jQuery(`.js-${this.id}`).on('blur', this.close_all.bind(this));
	}
	
	option_click_handler(event) {
		event.preventDefault();
		const $link = jQuery(event.currentTarget).find('a[href]').first();
		if ($link.length) {
			window.location.href = $link.attr('href');
		}
		super.option_click_handler(event);
	}
	last_viewed() {
		
	}
}
